import { Avatar, Divider, Link, List, ListItem, ListItemAvatar, ListItemText, Tooltip } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CalculateTwoTone from '@mui/icons-material/CalculateTwoTone';
//import { useDataContext } from '../../contexts/dataContext';

export default function EntidadesListado() {
  /*const { esAsistente, esJefe, usuario } = useDataContext()

    console.log(`usuario de contexto ${JSON.stringify(usuario)}`)
    console.log(`esJefe de contexto ${esJefe}`)
    console.log(`esAsistente de contexto ${esAsistente}`)*/
  const params = useParams()
  const idUsuario = params.idUsuario;
  const [entidades, setEntidades] = useState([])
  const cargarEntidades = async () => {
    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/division/${idUsuario}/${sessionStorage.getItem('idEntidad')}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    })

    const entidadesLeidas = await res.json()
    setEntidades(entidadesLeidas)
  }
  const verificarDisponible = () => {
    const idEntidad = sessionStorage.getItem('idEntidad')
    const idEntidadSuperior = sessionStorage.getItem('idEntidadSuperior')
    if (Number(idEntidad) === Number(1) || Number(idEntidad) === Number(2) || Number(idEntidadSuperior) === Number(1) || Number(idEntidadSuperior) === Number(2)) {
        return false
    }
    return true
}
  useEffect(() => {
    (async () => {
      await cargarEntidades()
    })();
    // eslint-disable-next-line
  }, [])

  return (
    <List sx={{ width: '100%', maxWidth: 560, bgcolor: 'background.paper', marginTop: 5 }}>
      <Divider variant="inset" component="li" />
      {entidades.map((entidad) => (
        <Fragment key={entidad.id}>
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <Avatar alt={`${entidad.siglas}`} src="/images/UAML.png" />
            </ListItemAvatar>
            <ListItemText
              primary={entidad.idPlan ? <><Link href={`/seguimientoSolicitudes/porPlan/${entidad.idPlan}`} style={{ marginTop: 20 }}>{entidad.nombre}</Link> {verificarDisponible() ? <Link href={`/proyectosEntidad/${entidad.idPlan}`} style={{ marginTop: 20 }}><Tooltip title="Ver avance presupuestal" arrow><CalculateTwoTone></CalculateTwoTone></Tooltip></Link>:<></>}</>: entidad.nombre}
              secondary={entidad.idPlan ? <></> : "Aún no tiene planeación"}
            />
          </ListItem>
          <Divider variant="inset" component="li" />
        </Fragment>
      ))}
      <Fragment key={'todas'}>
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <Avatar alt={`Ver todas`} src="/images/UAML.png" />
            </ListItemAvatar>
            <ListItemText
              primary={ <><Link href={`/seguimientoSolicitudes/todas`} style={{ marginTop: 20 }}>{'Todas'}</Link></>}
            />
          </ListItem>
          <Divider variant="inset" component="li" />
        </Fragment>

    </List>
  )
}